import { Link } from 'react-router';
import { SECTIONS } from './AppLayout';

export function DashboardPage() {
  return (
    <section className="space-y-4">
      <h1 className="font-heading text-2xl">أهلاً</h1>
      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {SECTIONS.map((s) => (
          <li key={s.path}>
            <Link to={s.path} className="block rounded-dar border border-sand bg-white p-4 hover:border-espresso">
              {s.label}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
